import { LocationIcon, UserIcon } from '@umanforge/common';
import { TaskIcon } from 'components/icons/task.icon';
import React from 'react';

interface TitleEventProps {
  taskName?: string | undefined
  location?: string | undefined
  users?: string[] | undefined
}

export const TitleEvent: React.FC<TitleEventProps> = ( { taskName, location, users } ) => {
  return (
    <>
      { taskName != null && <div className='border h-fit w-fit border-gray-200/60 px-0.5 ml-0.5 bg-white/20 rounded flex items-center'>
        <TaskIcon className='stroke-[0.2] text-gray-800 w-4 mr-0.5'/>
        { taskName }
      </div> }

      { location != null && <div className='border h-fit w-fit border-gray-200/60 px-0.5 ml-0.5 bg-white/20 rounded flex items-center'>
        <LocationIcon className='text-gray-700 h-4 w-4 stroke-linecap-round'/>
        { location }
      </div> }

      { ( users != null && users.length > 0 ) && <div className='h-fit w-fit ml-0.5 bg-white/20 rounded flex items-center' title={ users.join( ', ' )}>
        <UserIcon className='text-gray-900 w-4 ml-1'/>
        { users.map( ( userName, i ) => {
          return <div className='text-[10px] border h-fit w-fit border-gray-200/60 m-0.5 bg-white/10 rounded gap-x-1' key={ i + '_' + userName}> { userName } </div>;
        } ) }
      </div> }
    </>
  );
};